/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button } from "@nordcloud/gnui";
import { StyledLink } from "~/components";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { CloudAccountsTable } from "./components/CloudAccountsTable";

export function AccountsPage() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Cloud Accounts", uri: ROUTES.accounts.index },
  ];

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Cloud Accounts"
            customBreadcrumbs={breadcrumbsLabels}
          >
            <StyledLink to={ROUTES.accounts.create}>
              <Button icon="plus">Add Account</Button>
            </StyledLink>
          </BreadcrumbsBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <CloudAccountsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
